import { ApiBase } from '@/api/api'
import { makeGetRequest } from '@/api/fetchCalls'
import {
  FormAbandonmentParams,
  FormAbandonmentResponse,
  QuestionAbandonment,
} from '@/domain/model/form-analytics'

export const loadAbandonmentByResourceId = async ({
  resource_uid,
  ...params
}: FormAbandonmentParams): Promise<QuestionAbandonment[]> => {
  if (!resource_uid) {
    return Promise.resolve([])
  }

  const response = (await makeGetRequest(
    ApiBase + `/analytics/forms/${resource_uid}/question_metrics`,
    {
      params,
    }
  )) as FormAbandonmentResponse

  const sortedQuestions = [...response.questions].sort(
    (a, b) => b.drop_off_count - a.drop_off_count
  )

  return sortedQuestions
}
